import * as React from 'react';
import axios from 'axios';
import { Question } from './Question';
import scrollToComponent from 'react-scroll-to-component';

export const Questions = (props) => {

    const [currentquestion,setCurrentquestion] = React.useState(0);
    const [canContinue,setCanContinue] = React.useState(false);
    const [quizFinished,setQuizFinished] = React.useState(false);
    const [checkedAnswer,setCheckedAnswer] = React.useState(false);

    const container = React.useRef(null);

    React.useEffect(() => {
        if(quizFinished) {
            scrollToComponent(container.current, { offset: 0, align: "top", duration: 500, ease:'inOutSine'});
        }
    },[quizFinished]);

    const registerResult  = ( questionIdx, correct ) => {
        props.result [ questionIdx ] = correct;
    }

    const calculateScore = () => {
        return props.result.filter ( function ( e ) { return e; }).length;
    }

    const onAnswerQuestion = () => {
        setCanContinue(true);
    }

    const onCheckAnswer = () => {
        setCheckedAnswer(true);
    }

    const onDownloadCertificate = () => {
        axios.get(`${zmp_ajax.ajaxurl}?action=quiz_get_pdf&quiz_id=${props.quizId}&count=${props.data.length}&correct=${calculateScore()}`)
            .then(res => {

                const link = document.createElement('a');
                link.href = res.data.url;
                link.download="certificaat-digivaardigindezorg.pdf";

                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();

            });
    }

    const onNextQuestion = () => {
        setCurrentquestion(currentquestion+1);
        setQuizFinished(currentquestion === props.data.length - 1);
        setCanContinue(false);
        setCheckedAnswer(false);
    }

    return (
        <div className="questions">
            {props.data.map((question,idx) => <Question
                    data={question}
                    questionCount={props.data.length}
                    key={idx}
                    idx={idx}
                    isCurrentquestion={currentquestion === idx}
                    registerResult={registerResult}
                    visible={idx<=currentquestion}
                    onAnswerQuestion={onAnswerQuestion}
                    hasAnswered={canContinue}
                    checkAnswer={checkedAnswer}
                />
            )}
            { quizFinished && (
                <div className="result" ref={container}>{ props.feedbackImage && (<div className="image" style={ {backgroundImage : `url(${props.feedbackImage.uri})`}}  ><img src={props.feedbackImage.uri} title={props.feedbackImage.title} alt={props.feedbackImage.alt} /></div>)}Je hebt {calculateScore()} van de {props.data.length} vragen goed! <button className="download-certificate" onClick={onDownloadCertificate}>download je certificaat</button></div>
            )}
            { !quizFinished && (
                checkedAnswer ?
                    <button className="btn-next" onClick={onNextQuestion} disabled={!canContinue}>{ currentquestion === props.data.length - 1 ? 'afronden' : 'volgende vraag'}<i className="sldigitaal-glyph sldigitaal-icon-arrow-right"></i></button> :
                    <button className="btn-next" onClick={onCheckAnswer} disabled={!canContinue}>controleer antwoord<i className="sldigitaal-glyph sldigitaal-icon-arrow-right"></i></button>
            )}

        </div>
    );
}
